import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { types as sdkTypes, createImageVariantConfig } from '../../util/sdkLoader';
import { PROFILE_PAGE_PENDING_APPROVAL_VARIANT } from '../../util/urlHelpers';
import { denormalisedResponseEntities } from '../../util/data';
import { storableError } from '../../util/errors';
import { hasPermissionToViewData, isUserAuthorized } from '../../util/userHelpers';
import { parse } from '../../util/urlHelpers';
import { constructQueryParamName, isOriginInUse, isStockInUse } from '../../util/search';
import { convertUnitToSubUnit, unitDivisor } from '../../util/currency';

import {
  parseDateFromISO8601,
  getExclusiveEndDate,
  addTime,
  subtractTime,
  daysBetween,
  getStartOf,
} from '../../util/dates';

const { UUID } = sdkTypes;

const SHOW_STORE_REQUEST = 'app/StoreFrontPage/SHOW_STORE_REQUEST';
const SHOW_STORE_SUCCESS = 'app/StoreFrontPage/SHOW_STORE_SUCCESS';
const SHOW_STORE_ERROR = 'app/StoreFrontPage/SHOW_STORE_ERROR';

// Tipos de acción
const FETCH_LISTINGS_REQUEST = 'app/StoreFrontPage/FETCH_LISTINGS_REQUEST';
const FETCH_LISTINGS_SUCCESS = 'app/StoreFrontPage/FETCH_LISTINGS_SUCCESS';
const FETCH_LISTINGS_ERROR = 'app/StoreFrontPage/FETCH_LISTINGS_ERROR';

const SET_CATEGORIES_WITH_LISTINGS = 'app/StoreFrontPage/SET_CATEGORIES_WITH_LISTINGS';

// 2. Estado inicial
const initialState = {
  store: null,
  showError: null,
  loading: true,
  listings: [],
  loading_listings: false,
  error: null,
  categoriesWithListings: {},
  isOwner: false,
};

// 3. Reducer
export default function reducer(state = initialState, action = {}) {
  //console.log("🛍️ StoreFrontPage reducer action:", action);
  switch (action.type) {
    case SHOW_STORE_REQUEST:
      return { ...state, loading: true, showError: null };
    case SHOW_STORE_SUCCESS:
      return { ...state, loading: false, store: action.payload.store, isOwner: action.payload.isOwner };
    case SHOW_STORE_ERROR:
      return { ...state, loading: false, showError: action.error };
    case FETCH_LISTINGS_REQUEST:
      return { ...state, loading_listings: true, error: null };
    case FETCH_LISTINGS_SUCCESS:
      //console.log("action", action)
      return { 
        ...state, 
        loading_listings: false, 
        listings: action.payload.data, // Los listings están en data
        pagination: action.payload.meta // La paginación está en meta
      };
    case FETCH_LISTINGS_ERROR:
      return { 
        ...state, 
        loading_listings: false, 
        error: action.error 
      };
    case SET_CATEGORIES_WITH_LISTINGS:
      return { 
        ...state, 
        categoriesWithListings: action.payload 
      };
    default:
      return state;
  }
}

// 4. Action creators
export const setCategoriesWithListings = categoriesWithListings => ({ type: SET_CATEGORIES_WITH_LISTINGS, payload: categoriesWithListings, });
export const showStoreRequest = () => ({ type: SHOW_STORE_REQUEST });
export const showStoreSuccess = (store, isOwner) => ({ type: SHOW_STORE_SUCCESS, payload: {store, isOwner} });
export const showStoreError = error => ({ type: SHOW_STORE_ERROR, error });

// 5. Thunk (acción asíncrona)
export const showStore = storeId => dispatch => {
  //console.log("🫴🏻🫴🏻🫴🏻🫴🏻")
  dispatch(showStoreRequest());
  return fetch(`/api/store-by-id?id=${storeId}`)
    .then(res => res.json())
    .then(data => {
      //console.log("🐼", data)
      if (data.success) {
        dispatch(showStoreSuccess(data.store, false));
      } else {
        dispatch(showStoreError(data.error));
      }
    })
    .catch(e => dispatch(showStoreError(e.message)));
};

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
    //console.log("🥎🥎🥎🥎🥎🥎🥎", initialState);

    dispatch(showStoreRequest());

    const queryParams = parse(search, {
      latlng: ['origin'],
      latlngBounds: ['bounds'],
    });
  
    const { page = 1, address, origin, ...rest } = queryParams;
    //console.log("🐼🐼🐼", params, queryParams, params.id);
    const userBySlugUrl = `${process.env.REACT_APP_API_ROOT_URL.replace(/\/$/, '')}/api/user-by-slug?slug=${encodeURIComponent(params.id)}`;
    //console.log("🌹", userBySlugUrl)
    return fetch(userBySlugUrl)
      .then(res => res.json())
      .then(data => {
        //console.log("🐵🐵🐵🐵 Data usuario:", data);
        const storeId = data?.user?.id?.uuid ?? params.id;
        const isOwner = getState().user.currentUser?.id?.uuid === data?.authorId;

        if (data?.success && data?.user) {
          dispatch(showStoreSuccess(data.user, isOwner));
        } else {
          dispatch(showStoreError('Usuario no encontrado'));
          return null;
        }

        if (storeId) {
          return dispatch(searchStoreListings(storeId, queryParams, config));
        }

        return null;
      })
      .catch(err => {
        dispatch(showStoreError('Usuario no encontrado'));
        return null;
      });
  };
  
export const fetchStoreListings = (storeId, updatedURLParams, config) => async (dispatch, getState, sdk) => {
  dispatch({ type: FETCH_LISTINGS_REQUEST });

  //console.log("📦📦📦📦 Último valor:", storeId, updatedURLParams, config);
  /*
  // Obtener todas las keys del objeto
  const keys = Object.keys(updatedURLParams);
  
  // Obtener la última key (la más profunda en el árbol)
  const lastKey = keys[keys.length - 1];
  const lastValue = updatedURLParams[lastKey];

  console.log("�� Última key:", lastKey);
  console.log("📦 Último valor:", lastValue);
*/
  try {

    
      // Obtener todas las keys del objeto
    const keys = Object.keys(updatedURLParams);
    
    if (keys.length === 0) {
      //console.log("⚠️ No hay parámetros para procesar");
      return;
    }
    
    // Buscar el primer valor no null empezando desde el último elemento
    let validKey = null;
    let validValue = null;
    
    // Recorrer las keys de atrás hacia adelante
    for (let i = keys.length - 1; i >= 0; i--) {
      const currentKey = keys[i];
      const currentValue = updatedURLParams[currentKey];
      
      //console.log(`🔍 Verificando ${currentKey}: ${currentValue}`);
      
      if (currentValue !== null && currentValue !== undefined && currentValue !== '') {
        validKey = currentKey;
        validValue = currentValue;
        //console.log(`✅ Valor válido encontrado: ${validKey} = ${validValue}`);
        break;
      }
    }
    
    if (validKey === null) {
      //console.log("❌ Todos los valores son null, undefined o vacíos");
      return;
    }

    // Obtener configuración para las imágenes
    //const config = getState().config;
    const {
      aspectWidth = 1,
      aspectHeight = 1,
      variantPrefix = 'listing-card',
    } = config.layout.listingImage;
    const aspectRatio = aspectHeight / aspectWidth;
    
    const queryParams = {
      authorId: storeId, // filtra por el usuario/tienda
      [validKey]: validValue,
      //included: ['images'], // filtra por la categoría válida encontrada
      include: ['author', 'images'], // incluir autor e imágenes
      pub_isActive: true,
      pub_isProduct: true,
      'fields.listing': [
        'title',
        'geolocation',
        'price',
        'deleted',
        'state',
        'publicData.listingType',
        'publicData.transactionProcessAlias',
        'publicData.unitType',
        // Estos campos ayudan al renderizado de listings de 'purchase'
        'publicData.pickupEnabled',
        'publicData.shippingEnabled',
      ],
      'fields.user': ['profile.displayName', 'profile.abbreviatedName'],
      'fields.image': [
        'variants.scaled-small',
        'variants.scaled-medium',
        `variants.${variantPrefix}`,
        `variants.${variantPrefix}-2x`,
      ],
      // Configuración de variantes de imagen
      ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
      ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
      'limit.images': 1, // límite de imágenes por listing
      perPage: 24,
    };
    
    //console.log("Query params finales:", queryParams);
    // Llamada a la API de Sharetribe
    
    const response = await sdk.listings.query(queryParams);//stClient.listings.query(queryParams);
    //console.log("✅ Respuesta completa de la API:", response);
    //console.log("📦 Data:", response.data);
    //console.log("🖼️ Included:", response.included);
    
    // Procesar la respuesta y agregar entidades al marketplace
    const listingFields = config?.listing?.listingFields;
    const sanitizeConfig = { listingFields };
    
    // Agregar entidades al estado de Redux (esto procesa data + included)
    dispatch(addMarketplaceEntities(response, sanitizeConfig));

    const state = getState();
    // console.log("🏪 Estado después de addMarketplaceEntities:", {
    //     marketplaceEntities: state.marketplaceData?.entities,
    //     listingsInState: state.marketplaceData?.entities?.listing,
    //     imagesInState: state.marketplaceData?.entities?.image
    // });

    dispatch({
      type: FETCH_LISTINGS_SUCCESS,
      payload: response.data,
    });
  } catch (e) {
    //console.log("🍆🍆🍆🍆🍆")
    dispatch({
      type: FETCH_LISTINGS_ERROR,
      error: e,
    });
  }
};


export const fetchCategoriesWithListings = (categories, userId) => async (dispatch, getState, sdk) => {
  const results = {};
  await Promise.all(categories.map(async (category) => {
    try {
      const response = await sdk.listings.query({
        authorId: userId,
        //pub_category: category, // Ajusta el nombre si es necesario
        pub_categoryLevel1: category,
        perPage: 1,
        include: [],
      });
      results[category] = response.data.data.length > 0;
    } catch (e) {
      results[category] = false;
    }
  }));
  dispatch(setCategoriesWithListings(results));
};








export const searchStoreListings = (storeId, searchParams, config) => async (dispatch, getState, sdk) => {
  
  //dispatch({ type: 'app/StoreFrontPage/FETCH_LISTINGS_REQUEST' });
  dispatch({ type: FETCH_LISTINGS_REQUEST });
  // Funciones auxiliares
  const searchValidListingTypes = listingTypes => {
    return config.listing.enforceValidListingType
      ? {
          pub_listingType: listingTypes.map(l => l.listingType),
        }
      : {};
  };

  const omitInvalidCategoryParams = params => {
    const categoryConfig = config.search.defaultFilters?.find(f => f.schemaType === 'category');
    const categories = config.categoryConfiguration.categories;
    const { key: prefix, scope } = categoryConfig || {};
    const categoryParamPrefix = constructQueryParamName(prefix, scope);

    const validURLParamForCategoryData = (prefix, categories, level, params) => {
      const levelKey = `${categoryParamPrefix}${level}`;
      const levelValue = params?.[levelKey];
      const foundCategory = categories.find(cat => cat.id === levelValue);
      const subcategories = foundCategory?.subcategories || [];
      return foundCategory && subcategories.length > 0
        ? {
            [levelKey]: levelValue,
            ...validURLParamForCategoryData(prefix, subcategories, level + 1, params),
          }
        : foundCategory
        ? { [levelKey]: levelValue }
        : {};
    };

    const categoryKeys = validURLParamForCategoryData(prefix, categories, 1, params);
    const nonCategoryKeys = Object.entries(params).reduce(
      (picked, [k, v]) => (k.startsWith(categoryParamPrefix) ? picked : { ...picked, [k]: v }),
      {}
    );

    return { ...nonCategoryKeys, ...categoryKeys };
  };

  const priceSearchParams = priceParam => {
    const inSubunits = value => convertUnitToSubUnit(value, unitDivisor(config.currency));
    const values = priceParam ? priceParam.split(',') : [];
    return priceParam && values.length === 2
      ? {
          price: [inSubunits(values[0]), inSubunits(values[1]) + 1].join(','),
        }
      : {};
  };

  const datesSearchParams = datesParam => {
    const searchTZ = 'Etc/UTC';
    const datesFilter = config.search.defaultFilters.find(f => f.key === 'dates');
    const values = datesParam ? datesParam.split(',') : [];
    const hasValues = datesFilter && datesParam && values.length === 2;
    const { dateRangeMode, availability } = datesFilter || {};
    const isNightlyMode = dateRangeMode === 'night';
    const isEntireRangeAvailable = availability === 'time-full';

    const getProlongedStart = date => subtractTime(date, 14, 'hours', searchTZ);
    const getProlongedEnd = date => addTime(date, 12, 'hours', searchTZ);

    const startDate = hasValues ? parseDateFromISO8601(values[0], searchTZ) : null;
    const endRaw = hasValues ? parseDateFromISO8601(values[1], searchTZ) : null;
    const endDate =
      hasValues && isNightlyMode
        ? endRaw
        : hasValues
        ? getExclusiveEndDate(endRaw, searchTZ)
        : null;

    const today = getStartOf(new Date(), 'day', searchTZ);
    const possibleStartDate = subtractTime(today, 14, 'hours', searchTZ);
    const hasValidDates =
      hasValues &&
      startDate.getTime() >= possibleStartDate.getTime() &&
      startDate.getTime() <= endDate.getTime();

    const dayCount = isEntireRangeAvailable ? daysBetween(startDate, endDate) : 1;
    const day = 1440;
    const hour = 60;
    const minDuration = isEntireRangeAvailable ? dayCount * day - hour : hour;
    return hasValidDates
      ? {
          start: getProlongedStart(startDate),
          end: getProlongedEnd(endDate),
          availability: 'time-partial',
          minDuration,
        }
      : {};
  };

  const stockFilters = datesMaybe => {
    const hasDatesFilterInUse = Object.keys(datesMaybe).length > 0;
    return hasDatesFilterInUse ? {} : { minStock: 1, stockMode: 'match-undefined' };
  };

  const seatsSearchParams = (seats, datesMaybe) => {
    const seatsFilter = config.search.defaultFilters.find(f => f.key === 'seats');
    const hasDatesFilterInUse = Object.keys(datesMaybe).length > 0;
    return hasDatesFilterInUse && seatsFilter ? { seats } : {};
  };

  // Desestructurar los parámetros de búsqueda
  const { perPage = 24, price, dates, seats, sort, mapSearch, page, ...restOfParams } = searchParams;
  const priceMaybe = priceSearchParams(price);
  const datesMaybe = datesSearchParams(dates);
  const stockMaybe = stockFilters(datesMaybe);
  const seatsMaybe = seatsSearchParams(seats, datesMaybe);
  const sortMaybe = sort === config.search.sortConfig.relevanceKey ? {} : { sort };
//console.log("🔥🔥🔥", storeId)
  // Si quieres filtrar por tienda, agrega authorId: storeId aquí
  const params = {
    ...omitInvalidCategoryParams(restOfParams),
    ...priceMaybe,
    ...datesMaybe,
    ...stockMaybe,
    ...seatsMaybe,
    ...sortMaybe,
    ...searchValidListingTypes(config.listing.listingTypes),
    sort,
    perPage,
    page,
    authorId: storeId,
    include: ['author', 'images'],
    pub_listingType: ['free-listing'],
    pub_isActive: true,
    pub_isProduct: true,
    'fields.listing': [
      'title',
      'geolocation',
      'price',
      'deleted',
      'state',
      'publicData.listingType',
      'publicData.transactionProcessAlias',
      'publicData.unitType',
      'publicData.pickupEnabled',
      'publicData.shippingEnabled',
    ],
    'fields.user': ['profile.displayName', 'profile.abbreviatedName'],
    'fields.image': [
      'variants.scaled-small',
      'variants.scaled-medium',
      'variants.listing-card',
      'variants.listing-card-2x',
    ],
    ...createImageVariantConfig('listing-card', 400, 1),
    ...createImageVariantConfig('listing-card-2x', 800, 1),
    'limit.images': 1,
  };

  try {
    const response = await sdk.listings.query(params);
    const listingFields = config?.listing?.listingFields;
    const sanitizeConfig = { listingFields };
    //console.log("response", response)
    
    dispatch(addMarketplaceEntities(response, sanitizeConfig));
    //console.log("🌈🌈🌈🌈", response.data)
    dispatch({
      type: FETCH_LISTINGS_SUCCESS,
      payload: {
        data: response.data.data, // Los listings
        meta: response.data.meta, // La paginación completa
      },
    });
  } catch (e) {
    
    dispatch({
      type: FETCH_LISTINGS_ERROR,
      error: e,
    });
  }
};